import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { FlowInvoiceInsight } from 'src/app/_types/billing.types';
import { DatePeriodComponent } from 'src/app/shared/components/date-period/date-period.component';

/**
 * Same as the billing list's period cell, but reading the flow payload's
 * `periodStart` / `periodEnd` instead of `startDate` / `endDate`.
 */
@Component({
  selector: 'app-flow-invoice-period-renderer',
  standalone: true,
  imports: [DatePeriodComponent],
  template: `<app-date-period [startDate]="startDate" [endDate]="endDate" />`,
})
export class FlowInvoicePeriodRendererComponent
  implements ICellRendererAngularComp
{
  startDate: Date | undefined;

  endDate: Date | undefined;

  agInit(params: ICellRendererParams<FlowInvoiceInsight>): void {
    this.startDate = params.data?.periodStart
      ? new Date(params.data.periodStart)
      : undefined;

    this.endDate = params.data?.periodEnd
      ? new Date(params.data.periodEnd)
      : undefined;
  }

  refresh(): boolean {
    return false;
  }
}
